import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

// Dev-only "view as student" for super admins (#605). The server issues a
// student session carrying `impersonatedBy`; the super admin's own token is
// kept here, in this tab only, so "Return to my account" can put it back
// without the server re-issuing a staff session.

export const ORIGINAL_TOKEN_KEY = 'impersonation-original-token';

const storage = () => {
  try {
    return window.sessionStorage;
  } catch (_) {
    return null;
  }
};

export const saveOriginalToken = (token) => {
  try {
    if (token) storage()?.setItem(ORIGINAL_TOKEN_KEY, token);
  } catch (_) {
    // No session storage: return will fall back to signing out
  }
};

export const readOriginalToken = () => {
  try {
    return storage()?.getItem(ORIGINAL_TOKEN_KEY) || null;
  } catch (_) {
    return null;
  }
};

export const clearOriginalToken = () => {
  try {
    storage()?.removeItem(ORIGINAL_TOKEN_KEY);
  } catch (_) {
    // nothing kept
  }
};

export const isSuperAdmin = (user) => Array.isArray(user?.roles) && user.roles.includes(ROLES.SUPER_ADMIN);

/**
 * May the kept token be restored? Only an unexpired super admin session
 * belonging to the person the impersonated session names; anything else and
 * the caller signs out instead.
 *
 * @param {Object|null} originalClaims  the decoded kept token
 * @param {Object|null} impersonatedBy  from the impersonated session
 * @param {number} nowSeconds
 */
export function canReturnTo(originalClaims, impersonatedBy, nowSeconds) {
  if (!originalClaims || !impersonatedBy) return false;
  if (typeof originalClaims.exp !== 'number' || originalClaims.exp <= nowSeconds) return false;
  if (originalClaims.impersonatedBy) return false;
  const u = originalClaims.user;
  if (!isSuperAdmin(u) || u.roles.includes(ROLES.USER_ROLE_STUDENT)) return false;
  if (impersonatedBy.oid) return u.oid === impersonatedBy.oid;
  const email = String(u.email || u.emailaddress || u.preferred_username || '').toLowerCase();
  return Boolean(impersonatedBy.email) && email === impersonatedBy.email;
}
